import React from 'react';
import OptionButton from '../shared/OptionButton';
import { RunClubDifficulty } from '../../../types/enums';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const RunClubIntensityStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <OptionButton label="Hard" value={RunClubDifficulty.HARD} selected={answer === RunClubDifficulty.HARD} onClick={onAnswer} />
      <OptionButton label="Easy" value={RunClubDifficulty.EASY} selected={answer === RunClubDifficulty.EASY} onClick={onAnswer} />
    </div>
  );
};

export default RunClubIntensityStep;
